export default __webpack_public_path__ + "public/assets/images/076b45b28144e608350b9d31928855d3.png";